export const services = {
  en: {
    agile_software_development_services: {
      title: "Agile Software Development Services",
    },
    agile_software_development: {
      title: "Agile Software Development Company Poland",
    },
    ai_chatbot_development_services: {
      title: "AI Chatbot Development Services",
    },
    ai_development_services: {
      title: "AI Development Company | Custom AI, GenAI Solutions",
    },
    animated_websites_services: {
      title: "Animated Website Services. Design and Implementation",
    },
    application_maintenance_support: {
      title: "Remote IT Support & App Maintenance – bluesBrackets",
    },
    application_scaling: {
      title: "Application Scaling for Startups | Scalable Solutions",
    },
    arduino_development_services: {
      title: "Professional Arduino Development",
    },
    automated_data_processing: {
      title: "Polish Software House | UI/UX, Fullstack, Mobile, Embedded",
    },
    automated_regression_testing: {
      title: "Automated Regression Testing & End-to-End Development",
    },
    baremetal_programming: {
      title:
        "Embedded Systems & Bare Metal Programming Experts | bluesBrackets",
    },
    bespoke_mvp_development_company: {
      title: "Bespoke MVP & Custom Software Development Company",
    },
    bespoke_software_development_company: {
      title: "Bespoke Software Development Company",
    },
    bespoke_software: {
      title: "Bespoke Software Solutions for Startups & Enterprises",
    },
    best_programming_language_it: {
      title: "Expert IoT & Embedded Software Development | bluesBrackets",
    },
    bluetooth_application_for_android: {
      title: "Expert Embedded Android & Bluetooth App Development",
    },
    body_leasing: {
      title: "Leverage Body Leasing for React Native & Embedded",
    },
    business_intelligence_solutions: {
      title: "Business Intelligence Solutions | bluesBrackets",
    },
    chatbot_services: {
      title: "Custom AI Chatbot Solutions & Services",
    },
    cloud_adoption: {
      title: "Cloud Adoption & Digital Transformation Services",
    },
    cloud_application_development_services: {
      title:
        "Cloud Application Development Services | Polish Cloud Development",
    },
    cloud_migration_companies: {
      title: "Cloud Migration Consulting Services Company | bluesBrackets",
    },
    cross_platform_mobile_development: {
      title: "Cross-Platform Mobile Development",
    },
    cto_as_a_service: {
      title:
        "CTO as a Service - Future-Ready Software House: CTO, DevOps & UX/UI",
    },
    custom_cms_solutions: {
      title: "Custom CMS Solutions & Software Development",
    },
    custom_management_system: {
      title: "Custom Management Systems & AI-Driven Software",
    },
    custom_software_development_on_demand: {
      title: "Custom Software Development Services — bluesBrackets",
    },
    custom_software_development_service: {
      title: "Custom Software Development Services in Poland",
    },
    custom_web_app_development_services: {
      title: "Custom Web App & AI Development Services",
    },
    custom_web_app_development_solutions: {
      title: "Custom Web App Development Services | bluesBrackets",
    },
    data_center_migration_companies: {
      title: "Data Center Migration & IT Migration Services",
    },
    data_engineering_services: {
      title: "Data Engineering & Data Visualization Services",
    },
    dedicated_development_team: {
      title: "Hire a Dedicated Development Team in Poland",
    },
    dedicated_software_development_team: {
      title: "Dedicated Software Development Teams in Europe",
    },
    devops_as_a_service: {
      title: "DevOps as a Service | AWS Cloud Consulting",
    },
    devops_consulting_company: {
      title: "DevOps Consulting Company | bluesBrackets",
    },
    eaa_accessibility_compliance: {
      title: "EAA Accessibility & Compliance Software Development",
    },
    ecommerce_website_costs: {
      title: "Ecommerce Software Development & Website Costs",
    },
    electron_js: {
      title: "Build Scalable Desktop & Embedded Apps – bluesBrackets",
    },
    embedded_development_services: {
      title: "Custom Embedded Software Development Services",
    },
    embedded_software_development: {
      title: "Embedded & IoT Software Services | bluesBrackets",
    },
    embedded_software_engineering: {
      title: "Embedded Software Engineering Services | bluesBrackets",
    },
    embedded_software_outsourcing: {
      title: "Embedded Software Development Outsourcing",
    },
    embedded_software_staff_augmentation: {
      title: "Embedded Software Staff Augmentation",
    },
    end_to_end_it_solutions: {
      title: "End-to-End IT Solutions | Software House Poland",
    },
    energy_storage_systems_for_solar_power: {
      title: "Energy Storage & IoT Software Solutions",
    },
    enterprise_mobile_app_development: {
      title: "Enterprise Mobile App Development Company | bluesBrackets",
    },
    fixed_price_vs_time_and_material: {
      title: "Fixed Price vs. Time & Materials",
    },
    flutter_app_development: {
      title: "Flutter App Development Services | bluesBrackets",
    },
    flutter_development_services: {
      title: "Flutter App Development Services",
    },
    generative_healthcare: {
      title: "Healthcare IT Outsourcing & AI Software for Medical Innovators",
    },
    hardware_design: {
      title: "Expert Hardware Design Company | Custom Electronic Hardware",
    },
    hardware_development: {
      title: "Expert Hardware Development Services | bluesBrackets",
    },
    hire_dedicated_development_team: {
      title: "Hire Dedicated Development Teams in Poland – bluesBrackets",
    },
    hire_java_developers: {
      title:
        "Poland’s Leading Java Software House | Hire Expert Java Developers",
    },
    hybrid_mobile_app_development: {
      title: "Hybrid Mobile App Development Services",
    },
    integration_and_system_testing: {
      title: "Integration & System Testing Experts",
    },
    internet_of_things_development: {
      title: "IoT Product Development & Custom Software Solutions",
    },
    internet_of_things_smart_cities: {
      title: "IoT & Smart City Software Development | bluesBrackets",
    },
    ios_app_programming: {
      title: "Expert iOS App Development Company in Poland",
    },
    ios_development_language: {
      title: "Mobile App Development Languages & Services",
    },
    ios_pwa: {
      title: "iOS PWA Development Services | Cross-Platform Mobile Apps",
    },
    iot_companies: {
      title: "Industrial IoT Software Development Company",
    },
    iot_development_services: {
      title: "IoT Development Services | Custom IoT Devices & Solutions",
    },
    iot_device_management: {
      title: "IoT Device Management Platform & Custom IoT Solutions",
    },
    iot_embedded_solutions: {
      title: "Polish Software House | Custom IoT & Embedded Solutions",
    },
    iot_in_retail: {
      title: "IoT Software for Retail, Wearables, Property | bluesBrackets",
    },
    iot_industry_4_0: {
      title: "Industrial IoT & Industry 4.0 Software Solutions",
    },
    iot_mqtt: {
      title: "IoT MQTT Dashboard & Custom Embedded Solutions",
    },
    iot_product_development_company: {
      title:
        "IoT Product Development Company | Embedded & Fullstack Software House",
    },
    iot_wearables_technology: {
      title: "IoT & Wearable Tech Development | bluesBrackets",
    },
    it_system_testing: {
      title: "End-to-End IT System Testing & Integration Services",
    },
    javascript_backend_development: {
      title: "Backend Services & JavaScript Development | bluesBrackets",
    },
    leagacy_application_modernization: {
      title: "Legacy Application Modernization Services",
    },
    legacy_it_systems: {
      title: "Legacy IT Systems Modernization & Custom Software Development",
    },
    llm_product_development_llm_agency_llm_finetuning: {
      title: "LLM Product Development Agency | bluesBrackets",
    },
    machine_learning_companies: {
      title:
        "Machine Learning Consulting & Software Development Company Poland | UI/UX, Fullstack, Mobile, Embedded",
    },
    machine_learning_predictive_analytics: {
      title: "Machine Learning for Predictive Analytics",
    },
    machine_learning_supply_chain_technology: {
      title: "Machine Learning Supply Chain Solutions",
    },
    machine_vision_vs_computer_vision: {
      title: "Edge Computer Vision & Embedded Solutions | bluesBrackets",
    },
    medical_applications: {
      title: "Medical Device Software Development Services",
    },
    microcontroller_cpu: {
      title: "Expert Microcontroller & Embedded Development Services",
    },
    microservices_vs_monolithic: {
      title: "Microservices vs Monolithic: Expert Software Architecture",
    },
    mobile_development_services: {
      title: "Mobile App Development Services",
    },
    mvp_development: {
      title: "MVP Development Services | Custom MVP Development Company",
    },
    mvp_software_development: {
      title: "MVP Software Development Services | Custom MVP & POC Solutions",
    },
    nb_iot: {
      title: "NB-IoT Solutions & Agile Development",
    },
    nearshoring_it: {
      title: "IT Nearshoring & Software Development Poland",
    },
    nextjs_wordpress_services: {
      title: "Next.js & WordPress Services",
    },
    node_js_development_companies: {
      title: "Node.js, React & Next.js Development Poland – bluesBrackets",
    },
    node_js_development_company: {
      title: "Node.js Development Company | Trusted Node.js Services",
    },
    offshore_software_development: {
      title: "Trusted Offshore Software Development Company in Poland",
    },
    on_demand_services: {
      title: "On-Demand Software Development Services | bluesBrackets",
    },
    outsource_python_development: {
      title: "Outsource Python Development | Offshore Company",
    },
    outsourcing_software_projects: {
      title: "Software Development Outsourcing Company in Poland",
    },
    product_development_services: {
      title: "Software Product Development Services | bluesBrackets",
    },
    product_discovery_workshop: {
      title: "Product Discovery Workshops for Startups & Enterprises",
    },
    product_management_vs_product_owner: {
      title: "Custom Product & Project Management Software Solutions",
    },
    progressive_web_app_development_services: {
      title: "Progressive Web App Development Company | bluesBrackets Poland",
    },
    proof_of_concept_vs_prototype: {
      title: "Proof of Concept vs Prototype: Agile Software",
    },
    proof_of_concept: {
      title: "Proof of Concept & Proof of Principle Services",
    },
    pwa_development_services: {
      title: "PWA Development Services | iOS & Android",
    },
    react_development_services: {
      title: "React Development Services",
    },
    reactjs_web_development_company: {
      title: "ReactJS Web Development Company",
    },
    real_estate_software_companies: {
      title: "Real Estate Software Development Company",
    },
    rtos_development: {
      title: "Expert RTOS Development Services",
    },
    saas_cloud_solutions: {
      title: "SaaS Software Development Company: GDPR-Compliant Cloud",
    },
    sla_driven_software_development: {
      title: "SLA-Driven Software & Managed Services Poland",
    },
    software_delivery: {
      title: "Polish Software House: Agile Delivery & UI/UX",
    },
    software_development_companies: {
      title: "Software Development Companies | Custom Solutions",
    },
    software_development_outsourcing: {
      title: "Polish Software Development Outsourcing Company",
    },
    software_engineering_outsourcing: {
      title: "Software Engineering Outsourcing Poland",
    },
    software_house_landing: {
      title: "Software House Poland | Custom Web & Embedded Solutions",
    },
    software_integration_service: {
      title: "Software Integration & ChatGPT Integration Services",
    },
    software_maintenance: {
      title: "Software Maintenance & Legacy Services | bluesBrackets",
    },
    software_migration: {
      title: "Expert Software Migration Services | bluesBrackets",
    },
    software_prototyping: {
      title:
        "Expert Software Prototyping Services | Mobile, Embedded & Fullstack Prototyping",
    },
    staff_augmentation_services: {
      title: "IT Staff Augmentation Services in Poland",
    },
    staff_augmentation_vs_managed_services: {
      title: "Staff Augmentation vs Managed Services",
    },
    sw_engineering_services: {
      title: "Specialized Software Engineering Services | bluesBrackets",
    },
    system_to_system_integration: {
      title: "System to System Integration Services",
    },
    team_extension_it: {
      title: "Software Team Extension Services for Startups & Enterprises",
    },
    travel_software_development: {
      title: "Travel Software Development Company | Custom Travel Apps",
    },
    ux_ui_design_services: {
      title: "UX/UI Design Services. Project and Implementation",
    },
    wearable_apps: {
      title: "Sports & Healthcare Wearable App Development",
    },
    web_app_vs_desktop_app: {
      title: "Web Apps vs Desktop Apps: Expert Software",
    },
    web_app_vs_mobile_app: {
      title: "Web App vs Mobile App Development | Fullstack & UX/UI",
    },
    webapp_development_services: {
      title: "Custom Web App Development Services",
    },
    what_is_quality_assurance_testing: {
      title: "Quality Assurance Testing Services | bluesBrackets",
    },
    white_label_apps: {
      title: "White Label Mobile & Embedded App Experts",
    },
  },
  pl: {
    agile_software_development_polska: {
      title: "Agile Software Development Polska",
    },
    agile_software_development_services_pl: {
      title: "Usługi tworzenia oprogramowania metodą Agile",
    },
    ai_chatbot_development_services_pl: {
      title: "Usługi Tworzenia Chatbotów AI",
    },
    animowane_strony_internetowe: {
      title: "Animowane Strony Internetowe | Profesjonalne Usługi",
    },
    aplikacja_bluetooth_na_androida: {
      title: "Eksperci w Embedded Android i Bluetooth",
    },
    aplikacja_webowa_vs_aplikacja_desktopowa: {
      title: "Aplikacje webowe vs desktopowe | bluesBrackets",
    },
    aplikacja_webowa_vs_aplikacja_mobilna: {
      title: "Aplikacje webowe czy mobilne? Fullstack & UX/UI",
    },
    aplikacje_ios: {
      title: "Ekspercka firma tworząca aplikacje iOS w Polsce",
    },
    aplikacje_medyczne_software_house: {
      title: "Tworzenie oprogramowania medycznego",
    },
    aplikacje_mobilne_dla_biznesu: {
      title: "Aplikacje mobilne dla biznesu | bluesBrackets",
    },
    arduino_development_services_pl: {
      title: "Profesjonalny rozwój projektów Arduino",
    },
    automatyczne_przetwarzanie_danych: {
      title: "Polski Software House | UI/UX, Fullstack, Mobile, IoT",
    },
    automatyczne_testy_regresyjne: {
      title: "Automatyczne testy regresji i kompleksowy development",
    },
    bespoke_software_development_company_pl: {
      title: "Dedykowane oprogramowanie na zamówienie",
    },
    body_leasing_polska: {
      title: "Body leasing React Native i embedded",
    },
    cross_platform_mobile_development_pl: {
      title: "Rozwój aplikacji cross-platform (wieloplatformowych)",
    },
    cto_jako_usluga: {
      title:
        "Nowoczesny software house: Dyrektor IT jako usługa (CTO as a Service), DevOps, UX/UI",
    },
    devops_jako_usluga: {
      title: "DevOps jako Usługa | Doradztwo AWS Cloud",
    },
    dostawa_oprogramowania: {
      title: "Polski Software House: Agile & UI/UX",
    },
    eaa_dostepnosc_zgodnosc: {
      title: "Tworzenie oprogramowania zgodnego z EAA",
    },
    edge_ai_i_widzenie_komputerowe: {
      title: "Edge Computer Vision i Embedded | bluesBrackets",
    },
    electron_aplikacja_desktop: {
      title: "Skalowalne aplikacje desktopowe i embedded – bluesBrackets",
    },
    firma_konsultingowa_devops: {
      title: "Firma konsultingowa DevOps | bluesBrackets",
    },
    firma_rozwoju_ai: {
      title: "Rozwiązania AI szyte na miarę dla biznesu",
    },
    firmy_migracji_centrow_danych: {
      title: "Migracje Data Center i IT – Bezpieczne Usługi",
    },
    firmy_migracji_chmurowej: {
      title: "Konsulting migracji do chmury – bluesBrackets",
    },
    flutter_aplikacje_na_mobile: {
      title: "Tworzenie aplikacji Flutter | bluesBrackets",
    },
    flutter_development_services_pl: {
      title: "Usługi Rozwoju Aplikacji Flutter",
    },
    generatywna_sztuczna_inteligencja_w_opiece_zdrowotnej: {
      title: "Outsourcing IT i AI dla branży medycznej",
    },
    hybrydowy_rozwoj_aplikacji_mobilnych: {
      title: "Usługi tworzenia aplikacji hybrydowych",
    },
    integracja_i_programowanie: {
      title: "Integracje systemów i wdrożenia ChatGPT",
    },
    integracja_i_testowanie_systemowe: {
      title: "Bezpieczne testy systemowe i integracja",
    },
    integracje_systemow: {
      title: "Usługi integracji systemów IT",
    },
    internet_rzeczy_miasta_inteligentne: {
      title: "Oprogramowanie IoT i Smart City | bluesBrackets",
    },
    inzynieria_oprogramowania_embedded: {
      title: "Usługi inżynierii oprogramowania embedded | bluesBrackets",
    },
    iot_firmy: {
      title: "Tworzenie oprogramowania IoT dla przemysłu",
    },
    iot_mqtt_pl: {
      title: "IoT MQTT Dashboardy i rozwiązania embedded",
    },
    iot_przemysl_4_0: {
      title: "IIoT i Przemysł 4.0 – oprogramowanie na miarę",
    },
    iot_rozwiazania_embedded: {
      title: "Polski Software House | Rozwiązania IoT i Embedded",
    },
    iot_tworzenie_produktow: {
      title: "Tworzenie produktów IoT | Embedded & Fullstack Software House",
    },
    iot_urzadzenia_ubieralne: {
      title: "Rozwój IoT i Wearable | bluesBrackets",
    },
    iot_w_handlu: {
      title: "Oprogramowanie IoT dla handlu, wearables, nieruchomości",
    },
    iot_w_zarzadzaniu_urzadzeniami: {
      title: "Platforma zarządzania IoT i dedykowane rozwiązania",
    },
    javascript_backend_strony_internetowej: {
      title: "Usługi backend i JavaScript | bluesBrackets",
    },
    konsultacje_machine_learning: {
      title:
        "Konsultacje Machine Learning i Rozwój Oprogramowania | UI/UX, Fullstack, Mobile, Embedded",
    },
    koszty_strony_ecommerce: {
      title: "Koszty wdrożenia i rozwoju sklepu online",
    },
    microcontroller_cpu_polska: {
      title: "Eksperckie rozwiązania embedded i mikrokontrolerów",
    },
    migracja_oprogramowania: {
      title: "Ekspercka migracja oprogramowania | bluesBrackets",
    },
    mikroserwisy_vs_monolit: {
      title: "Mikroserwisy czy Monolit: Ekspercka Architektura",
    },
    modernizacja_aplikacji_legacy: {
      title: "Modernizacja aplikacji legacy dla firm",
    },
    mvp_development_pl: {
      title: "Usługi rozwoju MVP | Firma tworząca MVP dla startupów",
    },
    mvp_i_oprogramowanie_dedykowane: {
      title: "Dedykowane MVP i oprogramowanie szyte na miarę",
    },
    mvp_rozwoj_oprogramowania: {
      title: "Tworzenie MVP oprogramowania | Wdrażanie MVP i POC",
    },
    najlepszy_jezyk_programowania_dla_iot: {
      title: "Eksperci IoT i Embedded | bluesBrackets",
    },
    nb_iot_polska: {
      title: "NB-IoT, systemy wbudowane i zwinne IT",
    },
    nearshoring_it_polska: {
      title: "IT Nearshoring i rozwój oprogramowania Polska",
    },
    nextjs_wordpress_uslugi: {
      title: "Usługi Next.js i WordPress",
    },
    niestandardowe_rozwiazania_cms: {
      title: "Dedykowane CMS i oprogramowanie na miarę",
    },
    niestandardowe_uslugi_i_tworzenie_aplikacji_internetowych: {
      title: "Tworzenie dedykowanych aplikacji webowych | bluesBrackets",
    },
    niestandardowe_uslugi_tworzenia_aplikacji_www: {
      title: "Aplikacje webowe & AI szyte na miarę",
    },
    niestandardowy_system_zarzadzania: {
      title: "Systemy Zarządzania i Oprogramowanie AI",
    },
    node_js_agencje: {
      title: "Node.js, React i Next.js Polska – bluesBrackets",
    },
    node_js_firmy_programistyczne: {
      title: "Firma Node.js – zaufane usługi i rozwój",
    },
    okreslona_cena_vs_czas_i_materialy: {
      title: "Rozliczenie ryczałtowe czy T&M – co wybrać?",
    },
    oprogramowanie_business_intelligence: {
      title: "Business Intelligence dla firm | bluesBrackets",
    },
    oprogramowanie_dla_branzy_turystycznej: {
      title: "Tworzenie oprogramowania dla branży turystycznej",
    },
    oprogramowanie_dla_nieruchomosci: {
      title: "Tworzenie oprogramowania dla nieruchomości",
    },
    oprogramowanie_prototypowanie_polska: {
      title: "Profesjonalne prototypowanie oprogramowania",
    },
    oprogramowanie_szyte_na_miare: {
      title: "Dedykowane rozwiązania IT dla firm i startupów",
    },
    outsourcing_inzynierii_programowania: {
      title: "Outsourcing inżynierii oprogramowania Polska",
    },
    outsourcing_programowania_python: {
      title: "Outsourcing Python – Polska firma offshore",
    },
    outsourcing_projektow_it: {
      title: "Firma outsourcingowa IT — Polska",
    },
    outsourcing_rozwoju_oprogramowania: {
      title: "Polska firma outsourcingu IT",
    },
    programowanie_baremetal: {
      title: "Eksperci embedded i bare metal | bluesBrackets",
    },
    programowanie_offshore: {
      title: "Zaufana firma offshore software development w Polsce",
    },
    projektowanie_sprzetu: {
      title: "Ekspercka firma projektowa sprzętu | Własna elektronika",
    },
    proof_of_concept_pl: {
      title: "Usługi Proof of Concept i Proof of Principle",
    },
    prototypowanie_i_testy_rozwoju: {
      title: "Proof of Concept a Prototyp – Agile Software",
    },
    reactjs_software_house: {
      title: "Tworzenie aplikacji webowych ReactJS",
    },
    rozszerzenie_zespolu_it: {
      title: "Rozszerzanie zespołów IT dla startupów i firm",
    },
    rozwiazania_end_to_end: {
      title: "Kompleksowe rozwiązania IT | Software House Polska",
    },
    rozwoj_aplikacji_ios: {
      title: "Języki i usługi tworzenia aplikacji mobilnych",
    },
    rozwoj_aplikacji_mobilnych: {
      title: "Tworzenie aplikacji mobilnych na Androida i iOS",
    },
    rozwoj_aplikacji_react: {
      title: "Usługi Rozwoju Aplikacji React",
    },
    rozwoj_internetu_rzeczy: {
      title: "Rozwój produktów IoT i dedykowane oprogramowanie",
    },
    rozwoj_oprogramowania_embedded: {
      title: "Oprogramowanie Embedded i IoT | bluesBrackets",
    },
    rozwoj_produktu_llm_agencja_llm: {
      title: "Agencja wdrożeń LLM | bluesBrackets",
    },
    rozwoj_progresywnych_aplikacji_internetowych: {
      title:
        "Tworzenie progresywnych aplikacji webowych | bluesBrackets Polska",
    },
    rozwoj_sprzetu: {
      title: "Eksperckie usługi hardware | bluesBrackets",
    },
    rozwoj_systemow_wbudowanych: {
      title: "Usługi rozwoju systemów wbudowanych",
    },
    rtos_development_pl: {
      title: "Rozwiązania embedded z RTOS",
    },
    saas_chmurowe_rozwiazania: {
      title: "Rozwój oprogramowania SaaS: chmura zgodna z RODO",
    },
    saas_chmurowe_rozwi: {
      title: "saas_chmurowe_rozwi",
    },
    zania: {
      title: "Rozwój oprogramowania SaaS: chmura zgodna z RODO",
    },
    skalowanie_aplikacji: {
      title: "Skalowanie aplikacji dla startupów — rozwiązania skalowalne",
    },
    sla_i_uslugi_zarzadzane: {
      title: "Oprogramowanie SLA & usługi zarządzane Polska",
    },
    software_developmentowe_firmy: {
      title: "Firmy programistyczne | Rozwiązania na miarę",
    },
    software_house_landing_pl: {
      title:
        "Software House Polska | Tworzenie Aplikacji i Systemów Wbudowanych",
    },
    software_migration: {
      title: "Expert Software Migration Services | bluesBrackets",
    },
    specjalistyczne_uslugi_inzynierii_oprogramowania: {
      title: "Specjalistyczne usługi inżynierii oprogramowania",
    },
    sportowe_aplikacje: {
      title: "Rozwój aplikacji dla sportu i ochrony zdrowia",
    },
    staff_augmentation_services_pl: {
      title: "Staff Augmentation | Rozszerzenie zespołu IT",
    },
    systemy_it_legacy: {
      title: "Modernizacja systemów IT i dedykowane oprogramowanie",
    },
    systemy_magazynowania_energii_solarnej: {
      title: "Rozwiązania IT dla magazynowania energii i IoT",
    },
    testowanie_oprogramowania_polska: {
      title: "Usługi testowania jakości | bluesBrackets",
    },
    testowanie_systemow_it: {
      title: "Testy i integracja systemów IT end-to-end",
    },
    tworzenie_aplikacji_pwa: {
      title: "Tworzenie aplikacji PWA | iOS i Android",
    },
    tworzenie_pwa_na_ios: {
      title: "Tworzenie PWA na iOS – Aplikacje mobilne",
    },
    uczenie_maszynowe_analityka_predykcyjna: {
      title: "Uczenie maszynowe w analizie predykcyjnej",
    },
    uczenie_maszynowe_technologia_lancuch_dostaw: {
      title: "Rozwiązania ML dla łańcucha dostaw",
    },
    usluga_tworzenia_oprogramowania_na_zamowienie: {
      title: "Dedykowane usługi IT i outsourcing w Polsce",
    },
    uslugi_chatbot: {
      title: "Rozwiązania AI Chatbot dla Firm",
    },
    uslugi_inzynierii_danych: {
      title: "Usługi inżynierii danych i wizualizacji",
    },
    uslugi_na_zawolanie: {
      title: "Dedykowane usługi IT na żądanie | bluesBrackets",
    },
    uslugi_rozwoju_aplikacji_w_chmurze: {
      title: "Rozwój aplikacji chmurowych | Polska firma IT",
    },
    uslugi_rozwoju_iot: {
      title: "Usługi rozwoju IoT | Internet rzeczy IoT",
    },
    uslugi_rozwoju_produktow: {
      title: "Usługi rozwoju oprogramowania | bluesBrackets",
    },
    uslugi_tworzenia_oprogramowania_na_zamowienie: {
      title: "Usługi tworzenia oprogramowania na zamówienie — bluesBrackets",
    },
    utrzymanie_i_wsparcie_aplikacji: {
      title: "Zdalne wsparcie IT i utrzymanie aplikacji",
    },
    utrzymanie_oprogramowania: {
      title: "Utrzymanie oprogramowania i modernizacja | bluesBrackets",
    },
    ux_ui_design_uslugi: {
      title: "Profesjonalne usługi UX/UI design",
    },
    uzupelnienie_personelu_vs_uslugi_zarzadzane: {
      title: "Staff augmentation czy usługi zarządzane?",
    },
    warsztaty_product_discovery: {
      title: "Warsztaty Product Discovery dla startupów i firm",
    },
    wdrozenie_chmury: {
      title: "Usługi chmury i transformacji cyfrowej",
    },
    webapp_development_services_pl: {
      title: "Usługi tworzenia aplikacji webowych od bluesBrackets",
    },
    white_label_aplikacje: {
      title: "Eksperci white label dla aplikacji i IoT",
    },
    zarzadzanie_produktami_wlasciciel_produktu: {
      title: "Dedykowane systemy do zarządzania projektami",
    },
    zatrudnij_programistow_java: {
      title: "Liderzy Java w Polsce – zatrudnij ekspertów",
    },
    zatrudnij_wyspecjalizowany_zespol_programistow: {
      title: "Zatrudnij dedykowany zespół IT w Polsce",
    },
    zatrudnij_zespol_deweloperow: {
      title: "Zatrudnij dedykowany zespół IT w Polsce",
    },
    zespol_dedykowany_do_rozwoju_oprogramowania: {
      title: "Dedykowane zespoły programistyczne w Europie",
    },
  },
};
